import { Icon } from '../../UI/Icon';

export const WidgetChat: React.FC = () => {
    return (
        <div className="widget-chat">
            <Icon name="chat" size={22} />
        </div>
    );
};
